import BaseApi from '@/api/Base/BaseApi'
import { CommonListPayload } from '@/api/DatasetNode/types'
import {
  CreateModelPerformanceNodePayload,
  UpdateModelPerformanceNodePayload,
  ModelPerformanceNodeInfo,
  PerformanceResult,
  SavePerformanceJobsPayload,
  PerformanceTaskComparisonResponse
} from '@/api/ModelPerformance/types'

const ROOT = '/model-performance'

export default class ModelPerformanceApi extends BaseApi {
  createModelPerformanceNode(payload: CreateModelPerformanceNodePayload) {
    const { projectId, ...rest } = payload
    return this.agent.post(`/project/${projectId}${ROOT}/create`, rest)
  }

  updateModelPerformanceNode(payload: UpdateModelPerformanceNodePayload) {
    const { performanceNodeId, ...rest } = payload
    return this.agent.put(`${ROOT}/${performanceNodeId}`, rest)
  }

  getModelPerformanceNodeDetail(performanceNodeId: string) {
    return this.agent.get<ModelPerformanceNodeInfo>(`${ROOT}/${performanceNodeId}`)
  }

  getModelPerformanceResult(performanceNodeId: string) {
    return this.agent.get<PerformanceResult[]>(`${ROOT}/${performanceNodeId}/selected-tasks`)
  }

  savePerformanceJobs(payload: SavePerformanceJobsPayload) {
    const { performanceNodeId, selectedTasks } = payload
    return this.agent.post(`${ROOT}/${performanceNodeId}/selected-tasks`, selectedTasks)
  }

  getModelPerformanceTaskComparison(performanceNodeId: string, options: CommonListPayload & { search?: string }) {
    const {
      itemsPerPage,
      page,
      sortDir,
      sortKey,
      search,
    } = options

    return this.agent.get<PerformanceTaskComparisonResponse>(`${ROOT}/${performanceNodeId}/task-comparison`, {
      params: {
        search,
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }
}
